import React, { useContext, useRef, useState, useEffect } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import requests from '../utils/requests.js';
import Item from './Item.jsx';
import { s } from '../Style.jsx';

const Menu = () => {

    const categoryBar = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const scrollToBeginning = () => {
        if (categoryBar.current) {
            categoryBar.current.scrollTo({
                left: 0,
                behavior: "smooth"
            });
        }
    }
    const scrollToEnd = () => {
        if (categoryBar.current) {
            categoryBar.current.scrollTo({
                left: categoryBar.current.scrollWidth,
                behavior: "smooth"
            });
        }
    }

    const { authorizing, auth } = useContext(PersonContext);
    const [vendor, setVendor] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    const vendorName = new URLSearchParams(window.location.search).get("view").replace(/-/g, " ");
    useEffect(() => {
        if (authorizing) return;
        requests.getVendor(auth, { name: vendorName }).then(({ vendor, childVendors }) => {
            setVendor(vendor);
            setVendors(childVendors);
        });
    }, [authorizing]);

    useEffect(() => {
        if (vendor) setSelectedCategory((vendor?.categories || [])[0]);
    }, [vendor]);

    const handleCategory = category => {
        setSelectedSubCategory(null);
        setSelectedItem(null);
        setSelectedCategory(category);
    };

    const handleSubCategory = category => {
        setSelectedItem(null);
        setSelectedSubCategory(category);
    };

    if (vendor) return <>
        <div style={s.headerBox}>
            <div style={s.headerInnerBox}>

                <h1 style={{ marginBottom: 0, fontSize: 24 }}>{vendor.name || "Loading Menu"}</h1>

                {vendor.categories && <div style={{ ...s.row, marginBottom: 10, alignItems: "center", justifyContent: "space-between", gap: 20 }}>

                    {scrollPosition > 0 && <>
                        <div onClick={() => {
                            scrollToBeginning();
                        }}
                            style={{ flex: 1, marginBottom: 20, borderLeft: "1px solid #ccc", paddingLeft: 20, textAlign: "center" }}>
                            <i className="fas fa-arrow-left" style={{ fontSize: 20 }}></i>
                        </div>
                    </>}

                    <div style={{ flex: 1, maxWidth: "calc(100% - 60px)", textAlign: "left" }}>
                        <div
                            ref={categoryBar}
                            onScroll={e => {
                                const scrollLeft = e.target.scrollLeft;
                                const scrollWidth = e.target.scrollWidth;
                                const clientWidth = e.target.clientWidth;
                                setScrollPosition(scrollLeft);
                            }}
                            style={s.flexScroll}>
                            {(vendor?.categories || []).map((category, i) =>
                                <div key={i} style={s.scrollMenuButton(selectedCategory?.name === category.name)} onClick={() => handleCategory(category)}>{category.name}</div>)}
                        </div>
                    </div>

                    {!scrollPosition && <>
                        <div onClick={() => {
                            scrollToEnd();
                        }}
                            style={{ flex: 1, marginBottom: 20, borderLeft: "1px solid #ccc", paddingLeft: 20, textAlign: "center" }}>
                            <i className="fas fa-arrow-right" style={{ fontSize: 20 }}></i>
                        </div>
                    </>}

                </div>}


            </div>
        </div>
        <div style={s.paddingContainer}>
            <div style={s.mobileContainer}>

                {(authorizing || !vendor?.items) && <i className="fas fa-spinner fa-spin"></i>}

                {vendor && <>
                    {!!selectedCategory?.subCategories?.length && <div style={s.flexScroll}>
                        {selectedSubCategory && <s.ExitArrow does={() => handleSubCategory(null)} />}
                        {(vendor?.categories || []).find(c => c.name === selectedCategory?.name)?.subCategories?.map((category, i) =>
                            <button key={i} style={s.scrollMenuButton(selectedSubCategory?.name === category.name)} onClick={() => handleSubCategory(category)}>{category.name}</button>)}
                    </div>}
                    {selectedItem
                        ? <Item vendors={vendors}  item={selectedItem} vendorId={vendor.id} setSelectedItem={setSelectedItem} selectedItem={selectedItem} items={vendor.items} />
                        : <div style={{ marginTop: 10 }}>
                            {(vendor?.items || []).filter(item => item.tags?.includes(selectedSubCategory ? selectedSubCategory?.tag : selectedCategory?.tag)).map((item, i) =>
                                <Item key={i} item={item} vendorId={vendor.id} setSelectedItem={setSelectedItem} />)}
                        </div>}
                </>}

            </div>
        </div>
    </>;

}
export default Menu;

